import { Component, EventEmitter, Output } from '@angular/core';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-report-left-section',
  templateUrl: './report-left-section.component.html',
  styleUrls: ['./report-left-section.component.scss']
})
export class ReportLeftSectionComponent {
  selectedReport: any = "leads"

  constructor(private localStorage: LocalStorageService) {}

  accessObject: any = {};

  ngOnInit() {
    
    const storedReport = localStorage.getItem('selectedReport');


    this.accessObject = this.localStorage.checkCRUDAccess('report', 'Reports');

    console.log('Access Object:', this.accessObject); 

    console.log('Stored report:', storedReport);
    if (storedReport) {
      this.selectedReport = storedReport;
    } else {
      this.selectedReport = 'leads';
      localStorage.setItem('selectedReport', this.selectedReport);
    }
  }

  @Output() reportSelection = new EventEmitter<string>();

  onReportSelect(report: string) {
    this.selectedReport = report;
    this.reportSelection.emit(report);
  }
}
